import React from "react";
import { useI18n } from "@/lib/i18n";
import { Video } from "lucide-react";

/**
 * Phase 4 — Read-only gallery of published videos.
 *
 * Renders each entry as a native HTML5 <video controls preload="metadata">
 * without any autoplay so we don't burn user bandwidth. `playsInline` ensures
 * iOS Safari doesn't force full-screen playback.
 */
export default function VideoGallery({ paths = [], testidPrefix = "vg" }) {
  const { t } = useI18n();
  if (!paths || paths.length === 0) return null;
  const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-testid={`${testidPrefix}-root`}>
      {paths.map((p, i) => (
        <div key={p} className="relative rounded-xl overflow-hidden border border-slate-200 bg-black">
          <video
            src={`${backend}/api/files/${p}`}
            controls
            preload="metadata"
            playsInline
            className="w-full max-h-96 object-contain bg-black"
            data-testid={`${testidPrefix}-video-${i}`}
          />
          <div className="absolute top-1 left-1 bg-black/60 text-white rounded-full px-2 py-0.5 text-[10px] flex items-center gap-1">
            <Video size={10} /> {i + 1}
          </div>
        </div>
      ))}
    </div>
  );
}
